<z-modal [open]="open" [autoWidth]="true">
    <ng-container header>
        <div class="flex flex-row items-center gap-2 text-zen text-2xl">
            <i class="fal fa-analytics"></i>
            <h2 class=" font-semibold ">{{ "txtBenchmarks" | translate:language:ModuleNames.Shared }}
            </h2>
        </div>
        <i zenButton styles=" secondary icon-10" (click)="closeModal()" class="fa-regular fa-times"></i>
    </ng-container>
    <ng-container body>
        <div class="flex flex-col items-stretch w-screen max-w-lg gap-8">
            <div class="flex flex-col items-stretch gap-4">
                <h5 class="text-primary-light font-semibold uppercase text-xs">{{ "general" |
                    translate:language:ModuleNames.Shared }}</h5>
                <z-toggle *ngIf="data?.previousData" [(ngModel)]="benchmarkOptions.showPrevious"
                    [label]="'txtPrevious'|translate:language:ModuleNames.Shared"></z-toggle>
                <z-toggle [(ngModel)]="benchmarkOptions.showMENA"
                    [label]="'txtGlobal'|translate:language:ModuleNames.Shared"
                    (ngModelChange)="toggleTopPerformer()"></z-toggle>
                <z-toggle [(ngModel)]="benchmarkOptions.showTopPerformers"
                    [label]="'Top Performers'|translate:language:ModuleNames.Shared"
                    [disable]="!benchmarkOptions.showMENA"></z-toggle>
            </div>
            <div class="flex flex-col items-stretch gap-4">
                <h5 class="text-primary-light font-semibold uppercase text-xs">{{ "Segments"
                    |translate:language:ModuleNames.Shared }}</h5>
                <z-toggle [(ngModel)]="benchmarkOptions.showCountry" [disable]="!availableCountry"
                    [label]="('country'|translate:language:ModuleNames.Shared)+ ': ' + benchmarkOptions.regionOrCountryText"></z-toggle>
                <z-toggle [(ngModel)]="benchmarkOptions.showIndustry" [disable]="!availableIndustry"
                    [label]="('industry'|translate:language:ModuleNames.Shared) + ': ' + benchmarkOptions.industryText"></z-toggle>

            </div>
        </div>
    </ng-container>

    <ng-container footer>
        <a zenButton styles="secondary height-10" (click)="closeModal()">{{'btn_cancel'|
            translate:language:ModuleNames.Shared}}</a>
        <a zenButton styles="exp height-10" (click)="fetchBenchmark()">{{'ApplyBenchmark'|
            translate:language:ModuleNames.Shared}}</a>
    </ng-container>
</z-modal>